import React from 'react';
import { Box, Heading, Text, UnorderedList, ListItem, Link } from '@chakra-ui/react';

export const NraActionPistol = () => {
  return (
    <Box>
      <Text mb={4} color="black">
        <strong>Contact:</strong> Jim Flagg (<Link href="mailto:b737jim@aol.com" color="blue.500">b737jim@aol.com</Link>)
      </Text>

      <Text mb={4} color="black">
        NRA Action Pistol Matches are open to all individuals who are interested in "Action" courses of fire. These events combine speed and accuracy while shooting at multiple targets. All shots are shot with the shooter in a stationary position. All courses of fire are run on par time, where all shots must be completed in a set time.
      </Text>

      <UnorderedList spacing={2} ml={6} mb={4}>
        <ListItem><strong>When:</strong> The last Sunday of each month.</ListItem>
        <ListItem><strong>Time:</strong> Setup at 7:30 AM; Match at 9:00 AM.</ListItem>
        <ListItem><strong>Where:</strong> In the berm just East of the East range where the bowling pin matches are held.</ListItem>
        <ListItem><strong>Who:</strong> Anyone! Entry fee is $10 for members, and $15 for non members. These fees will pay for targets, backers, stands and lumber to hold the targets.</ListItem>
      </UnorderedList>

      <Heading as="h3" size="md" mb={3} color="black">Equipment:</Heading>
      <Text mb={4} color="black">
        You will need a semiautomatic pistol or revolver. A holster that is capable of a fast draw and magazine or speed loader holders. You should bring at least 200 rounds of ammunition. You may use any caliber pistol for these events however, heavier calibers are harder to use for these fast shooting events. Most events are 48 shots each. Because of this berm's location, a lawn chair and drinks to stay hydrated should be considered. Match Rules and information can be found on the NRA website.
      </Text>

      <Text mb={4} color="black">
        <Link href="#" color="blue.500">NRA: Action Pistol: Getting Started</Link>
      </Text>

      <Text mb={4} color="black">
        <Link href="#" color="blue.500">NRA: Action Pistol Rules (PDF)</Link>
      </Text>

      <Heading as="h3" size="md" mb={3} color="black">Courses of Fire:</Heading>
      <Text mb={4} color="black">
        We are somewhat limited to the following events, because of the depth of this berm. We will usually do four of these events for each match.
      </Text>

      <UnorderedList spacing={2} ml={6} mb={4}>
        <ListItem>Los Alamitos</ListItem>
        <ListItem>International Rapid Fire (Modified)</ListItem>
        <ListItem>Barricade Event (Modified)</ListItem>
        <ListItem>Falling Plate Event</ListItem>
        <ListItem>Tyro Event</ListItem>
        <ListItem>Crawford Barricade Event</ListItem>
        <ListItem>Ambidextrous Match</ListItem>
        <ListItem>Unsupported Standard Match</ListItem>
        <ListItem>Barricade Event</ListItem>
        <ListItem>We will try to hold at least one NRA sanctioned match each year.</ListItem>
      </UnorderedList>

      <Text mb={4} color="black">
        All visitors to Golden Gun Club must sign the Visitors Waiver. You only have to sign the waiver once a year, and it will be kept on file at the clubhouse. Sign the Visitor Waiver Online.
      </Text>
    </Box>
  );
};